import React from "react"
import { GenericVerifiedContent } from "../generic/GenericVerifiedContent"

export const EmailVerified = ({ handleOpenLoginDialog }) => {
  return (
    <GenericVerifiedContent
      handleOpenLoginDialog={handleOpenLoginDialog}
      label={<>Thanks for verifying! <br></br> Get started by setting up your profile.</>}
    />
  )
}